import { QuestionCategory, QuestionType } from "@/api/user/useGetMyQuestions";
import { useGetMySummary } from "@/api/user/useGetMySummary";
import { SignupQuestionnaire } from "@/components/Signup/SignupQuestionnaire";
import { QuestionnaireFlowQuestion } from "@/types/question.types";
import { Center, Loader } from "@mantine/core";

const signupQuestions: QuestionnaireFlowQuestion[] = [
  {
    slug: "identityVerification",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "본인인증을 진행해주세요",
    subtitle: "휴대폰 본인인증이 필요합니다",
    extra: {},
  },
  {
    slug: "nickname",
    category: QuestionCategory.SIGNUP,
    type: QuestionType.TEXT,
    title: "오프 이벤트에서 사용할 닉네임을 정해주세요",
    extra: {},
  },
];

export function KakaoSignupPage() {
  const { data: userSummary, isPending } = useGetMySummary();

  if (isPending) {
    return (
      <Center h="100%">
        <Loader />
      </Center>
    );
  }

  if (userSummary) {
    return (
      <SignupQuestionnaire questions={signupQuestions} isKakaoSignup userSummary={userSummary} />
    );
  }
}
